export { UpdatePropertyBuildingDetailSchema, updatePropertyBuildingDetailSchema } from './shared'
